import React, { useEffect, useMemo, useState } from "react";

const ChangeRateDropdown = ({ control, errors, setValue, watch }) => {
  const [changeRate, setChangeRate] = useState({
    direction: "+",
    value: "0",
  });

  const options = useMemo(
    () => [
      { value: "+", label: "+" },
      { value: "-", label: "-" },
    ],
    []
  );

  useEffect(() => {
    setValue("change_rate", changeRate);
  }, [setValue, changeRate]);

  const handleDirectionChange = (e) => {
    const newDirection = e.target.value;
    setChangeRate((prev) => ({
      ...prev,
      direction: newDirection,
    }));
  };

  const handleValueChange = (e) => {
    const newValue =
      e.target.value === "" ? "" : parseFloat(e.target.value) || 0;
    setChangeRate((prev) => ({
      ...prev,
      value: newValue,
    }));
  };

  return (
    <div>
      <div className="w-100 d-flex flex-row align-items-center gap-1">
        <select
          value={changeRate.direction}
          style={{ height: "35px" }}
          onChange={handleDirectionChange}
          className={`form-select w-25 ${
            errors.change_rate ? "is-invalid" : ""
          }`}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <input
          style={{
            height: "35px",
            border: "1px solid #DEE2E6",
            padding: "5px",
          }}
          className="w-75"
          type="number"
          value={changeRate.value === 0 ? "" : changeRate.value}
          onChange={handleValueChange}
          onFocus={() => {
            setChangeRate((prev) => ({
              ...prev,
              value: "",
            }));
          }}
          onBlur={() => {
            setChangeRate((prev) => ({
              ...prev,
              value: prev.value === "" ? 0 : prev.value,
            }));
          }}
        />
      </div>
      {errors.change_rate && (
        <span className="error-message">{errors.change_rate.message}</span>
      )}
    </div>
  );
};

export default ChangeRateDropdown;
